module.exports = __webpack_public_path__ + "img/expense.c4a6c45f.svg";